import { Request, UnaryResponse } from 'grpc-web';
import { SERVER_DEBUG_LOG_ENABLED } from 'src/util/feature-flags';
import { logServerError, logServerSuccess, nextServerLogId } from 'src/util/server-log';

/** Called at the transport boundary, including auth calls and each refresh retry. */
export async function invokeWithBackendLog<Req, Res>(
  request: Request<Req, Res>,
  invoker: (request: Request<Req, Res>) => Promise<UnaryResponse<Req, Res>>,
  attempt: number,
): Promise<UnaryResponse<Req, Res>> {
  if (!SERVER_DEBUG_LOG_ENABLED) return invoker(request);
  const startedAt = Date.now();
  const id = nextServerLogId();
  const method = request.getMethodDescriptor().getName();
  const payload = request.getRequestMessage();
  try {
    const response = await invoker(request);
    logServerSuccess('BACKEND gRPC', method, response.getResponseMessage(), {
      id, request: payload, durationMs: Date.now() - startedAt,
      transport: { attempt, status: response.getStatus(), metadata: response.getMetadata() },
    });
    return response;
  } catch (error: unknown) {
    logServerError('BACKEND gRPC', method, error, {
      id, request: payload, durationMs: Date.now() - startedAt, transport: { attempt },
    });
    throw error;
  }
}
